import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class StoreHistoryModule extends VuexModule {
  public ids: string[] | number[] = [];
  public orderId: string | number = null;

  @Mutation
  public setIds(ids): void {
    this.ids = ids;
  }

  @Action
  public updateIds(ids) {
    this.context.commit("setIds", ids);
  }

  @Mutation
  public setOrderId(orderId): void {
    this.orderId = orderId;
  }

  @Action
  public updateOrderId(orderId) {
    this.context.commit("setOrderId", orderId);
  }
}
